import { render, staticRenderFns } from "./ChargebeeUpsellMarketingDomainsItem.vue?vue&type=template&id=dbb41a78&scoped=true&"
import script from "./ChargebeeUpsellMarketingDomainsItem.vue?vue&type=script&lang=js&"
export * from "./ChargebeeUpsellMarketingDomainsItem.vue?vue&type=script&lang=js&"
import style0 from "./ChargebeeUpsellMarketingDomainsItem.vue?vue&type=style&index=0&id=dbb41a78&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbb41a78",
  null
  
)

export default component.exports